<div *ngIf="cargandoSpinnerEliminar || cargandoSpinner" class="d-flex justify-content-center mt-5">
    <div class="col mb-3-9 text-center mt-5">
        <img src="../../assets/img/mascota-loader.png" style="max-width: 200px;" alt="" class="mb-3">
        <ngb-progressbar type="success" [value]="progreso"></ngb-progressbar>
    </div>
</div>
<div *ngIf="!cargandoSpinnerEliminar && !cargandoSpinner && !banderaInfoAcademica"
    class="d-flex justify-content-center px-0 mx-0 mt-5">
    <div class="col mb-3 col mb-3 col-lg-8">
        <!-- HEAD -->
        <div class="d-flex justify-content-between align-items-center bg-secondary text-white p-3">
            <div class="d-none d-lg-block fs-5 m-0">
                <span class="vag-bold-font text-uppercase">Inscripción </span>
                <span>Información académica</span>
            </div>
            <div class="d-block d-lg-none">
                <label class="fs-5 m-0 vag-bold-font text-uppercase">Inscripción</label>
                <label class="fs-5 m-0">Información académica</label>
            </div>
            <button (click)="logout()" type="button" class="d-inline-flex btn btn-outline text-white">
                <label class="d-none d-lg-block mr-3 fs-5">Salir</label>
                <fa-icon [icon]="powerOffIcon" size="lg" class="text-white"></fa-icon>
            </button>
        </div>
        <div class="menu-cabecera d-flex justify-content-center">
            <div class="col col-lg-8">
                <img src="../../assets/img/step1.png" style="max-width: 100%;" alt="">
            </div>
        </div>

        <!-- CONTENT -->

        <!-- Alumnos -->
        <div *ngFor="let alumnoItem of alumnos;let i=index">
            <div class="d-flex justify-content-between align-items-center bg-lightblue text-white p-3">
                <label class="fs-5 m-0">Datos <span class="vag-bold-font text-uppercase">Alumno</span> 
                        <span class="vag-bold-font text-uppercase" *ngIf="i>=1"> {{i + 1}}</span></label>
                <h5 style="cursor: pointer" (click)="eliminarAlumno(i); verificarCamposAlumnos($event)"
                    *ngIf="alumnoItem != alumnos[0]" class="vag-bold-font text-white">Eliminar <span
                        aria-hidden="true">&times;</span></h5>
            </div>
            <div class="d-block d-md-flex mt-4">
                <div class="col mb-3">
                    <label class="label_title_textfield text-truncate fs-5">Nombre *</label>
                    <input [(ngModel)]="alumnoItem.firstname" type="text"
                        class="form-control fs-5  {{alumnoItem.campoVacioNombre}}" placeholder=""
                        (ngModelChange)="verificarCamposAlumnos($event) ; campoVacioNombre(alumnoItem.firstname, alumnoItem)"
                        aria-describedby="basic-addon1">
                </div>
                <div class="col mb-3">
                    <label class="label_title_textfield text-truncate fs-5">Apellidos *</label>
                    <input [(ngModel)]="alumnoItem.lastname"
                        (ngModelChange)="verificarCamposAlumnos($event) ; campoVacioApellido(alumnoItem.lastname, alumnoItem)"
                        type="text" class="form-control fs-5 {{alumnoItem.campoVacioApellido}}" placeholder=""
                        aria-describedby="basic-addon1">
                </div>
                <div class="col mb-3 ">
                    <label class="label_title_textfield text-truncate fs-5">Fecha de nacimiento *</label>
                    <div class="form-group">
                        <div class="input-group">
                            <input [(ngModel)]="alumnoItem.dobDatePicker" placeholder="dd/mm/aaaa" class="form-control fs-5"
                                [ngClass]="alumnoItem.campoVacionDob" [minDate]="{year:2000, month: 1, day: 1}"
                                (ngModelChange)="alumnoItem.age = calcularEdadAlumno(alumnoItem) ; verificarCamposAlumnos($event) ; campoVacioDob(alumnoItem.dobDatePicker, alumnoItem)"
                                ngbDatepicker #alumnoBtd="ngbDatepicker" readonly>
                            <div class="input-group-append">
                                <span class="btn btn-link border" (click)="alumnoBtd.toggle()">
                                    <fa-icon [icon]="calendarIcon" size="md" class="mx-1 text-dark">
                                    </fa-icon>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col mb-3">
                    <label class="label_title_textfield text-truncate fs-5">Sexo *</label>
                    <div class="input-group-prepend">
                        <select [(ngModel)]="alumnoItem.sexo" class="form-control fs-5">
                            <option value="hombre">Hombre</option>
                            <option value="mujer">Mujer</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end align-items-end mt-2 mb-3">
            <button (click)="agregarAlumno() ; verificarCamposAlumnos($event)" type="button"
                class="btn btn-secondary btn-lg">Añadir alumno</button>
        </div>

        <!-- Tutor -->
        <div class="d-flex justify-content-between align-items-center bg-lightblue text-white p-3">
            <label class="fs-5 m-0">Datos <span class="vag-bold-font text-uppercase">Padre/Madre/Tutor</span></label>
        </div>
        <div class="d-block d-md-flex mt-4">
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Nombre *</label>
                <input [(ngModel)]="tutor.firstname" type="text" class="form-control fs-5" [formControl]="campoText1"
                    placeholder="" aria-describedby="basic-addon1">
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Apellidos *</label>
                <input [(ngModel)]="tutor.lastname" type="text" class="form-control fs-5" [formControl]="campoText2"
                    placeholder="" aria-describedby="basic-addon1">
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Fecha de nacimiento *</label>
                <div class="form-group">
                    <div class="input-group">
                        <input class="form-control fs-5" placeholder="dd/mm/aaaa" [(ngModel)]="tutor.dobDatePicker"
                            [minDate]="{year: 1900, month: 1, day: 1}" [formControl]="campoText3"
                            (ngModelChange)="tutor.age = calcularEdadTutor(tutor)" ngbDatepicker
                            #tutorDp="ngbDatepicker" readonly>
                        <div class="input-group-append">
                            <span class="btn btn-link border" (click)="tutorDp.toggle()">
                                <fa-icon [icon]="calendarIcon" size="md" class="mx-1 text-dark">
                                </fa-icon>
                            </span>
                        </div>
                        <div *ngIf="errorEdadTutor" class="alert alert-danger">
                            <div>
                                Debe ser mayor de edad para registrarte.
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Sexo *</label>
                <div class="input-group-prepend">
                    <select [(ngModel)]="sexo" class="form-control fs-5">
                        <option value="hombre">Hombre</option>
                        <option value="mujer">Mujer</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="d-block d-md-flex mt-4">
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Parentesco *</label>
                <div class="input-group-prepend">
                    <select [(ngModel)]="tutor.parentesco" class="form-control fs-5">
                        <option value="Madre">Madre</option>
                        <option value="Padre">Padre</option>
                        <option value="Otro">Otro</option>
                    </select>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Documento *</label>
                <div class="input-group-prepend">
                    <select [(ngModel)]="documento" (ngModelChange)="onChangeDocumento($event)"
                        class="form-control fs-5">
                        <option value="DNI" selected="selected">DNI</option>
                        <option value="NIE">NIE</option>
                        <option value="passport">Pasaporte</option>
                    </select>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Número *</label>
                <input [(ngModel)]="tutor.numberDNI" type="text" class="form-control fs-5"
                    [formControl]="campoNumeroDocumento" placeholder=""
                    (ngModelChange)="tutor.numberDNI= ($event) ? $event.toUpperCase() : undefined ; validarDoc(tutor.numberDNI)"
                    aria-describedby="basic-addon1">
                <div *ngIf="(campoNumeroDocumento.invalid || !documentoValido) && (campoNumeroDocumento.dirty || campoNumeroDocumento.touched)"
                    class="alert alert-danger">
                    <div>
                        Docúmento invalido
                    </div>
                </div>
                <div *ngIf="existeDNI" class="alert alert-danger">
                    <div>
                        DNI en uso. Accede desde el Área del Tutor.
                    </div>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Teléfono móvil *</label>
                <input [(ngModel)]="tutor.phone1" type="number" class="form-control fs-5" [formControl]="campoText5"
                    placeholder="" aria-describedby="basic-addon1" onKeyPress="if(this.value.length==9) return false;">
                <div *ngIf="campoText5.invalid && (campoText5.dirty || campoText5.touched)" class="alert alert-danger">
                    <div *ngIf="campoText5.errors.required">
                        El teléfono es requerido.
                    </div>
                    <div *ngIf="campoText5.errors.pattern">
                        Deben ser 9 dígitos
                    </div>
                </div>
            </div>
        </div>
        <div class="d-block d-md-flex my-4">
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Tipo de via *</label>
                <div class="input-group-prepend">
                    <select [(ngModel)]="tutor.tipoVia" class="form-control fs-5">
                        <option *ngFor="let type of viaTypes" [value]="type.value">{{type.label}}</option>
                    </select>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Dirección *</label>
                <input [(ngModel)]="tutor.address" type="text" class="form-control fs-5" [formControl]="campoText6"
                    placeholder="" aria-describedby="basic-addon1">
            </div>
            <div class="col mb-3">
                <div class="d-block d-md-flex p-0 m-0">
                    <div class="col mb-3 p-0 my-0 ml-0 mr-1">
                        <label class="label_title_textfield text-truncate fs-5">Número *</label>
                        <input [(ngModel)]="tutor.number" type="text" class="form-control fs-5"
                            [formControl]="campoNumeroDir" placeholder="" aria-describedby="basic-addon1">
                    </div>
                    <div class="col mb-3 p-0 m-0">
                        <label class="label_title_textfield text-truncate fs-5">Código postal *</label>
                        <input [(ngModel)]="tutor.zip" type="text" class="form-control fs-5" [formControl]="campoText7"
                            placeholder="" (ngModelChange)="obtenerMunicipioXCodigoPostal(tutor.zip)"
                            aria-describedby="basic-addon1">
                    </div>
                </div>



            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Municipio *</label>
                <input [(ngModel)]="tutor.municipality" type="text" class="form-control fs-5" [formControl]="campoText8"
                    placeholder="" aria-describedby="basic-addon1">
            </div>
        </div>

        <!-- Datos de acceso -->
        <div class="d-flex justify-content-between align-items-center bg-lightblue text-white p-3">
            <label class="fs-5 m-0">Datos <span class="vag-bold-font text-uppercase">Acceso</span></label>
        </div>
        <div class="d-block d-md-flex my-4">
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Correo electrónico *</label>
                <input type="email" [(ngModel)]="tutor.email" [formControl]="email" class="form-control fs-5" id="email"
                    (ngModelChange)="validarEmails($event); errorFirebase = false" [disabled]="modoEdicion" required>
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                    <div *ngIf="email.errors.required">
                        El correo es requerido.
                    </div>
                    <div *ngIf="email.errors.pattern">
                        Ingrese un correo valido.
                    </div>
                </div>
                <div *ngIf="errorFirebase" class="alert alert-danger">
                    <div>
                        Email en uso. Accede desde el Área del Tutor.
                    </div>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Repetir correo *</label>
                <input [(ngModel)]="confirmacionEmail" class="form-control fs-5" type="email" placeholder=""
                    (paste)="false" (ngModelChange)="validarEmails($event)" aria-describedby="basic-addon1"
                    [disabled]="modoEdicion">
                <div *ngIf="tutor.email != confirmacionEmail" class="alert alert-danger">
                    <div>
                        La cuenta de correo no coincide. Por favor revísala.
                    </div>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Contraseña *</label>
                <input [(ngModel)]="tutor.password" type="password" class="form-control fs-5" placeholder=""
                    (ngModelChange)="validarPassword($event)" [formControl]="password" aria-describedby="basic-addon1"
                    required>
                <div *ngIf="tutor.password?.length > 0 && tutor.password?.length <= 7" class="alert alert-danger">
                    <div>
                        La contraseña debe tener un mínimo de 8 caracteres
                    </div>
                </div>
            </div>
            <div class="col mb-3">
                <label class="label_title_textfield text-truncate fs-5">Repetir Contraseña *</label>
                <input [(ngModel)]="confirmacionPassword" class="form-control fs-5" type="password" placeholder=""
                    (ngModelChange)="validarPassword($event)" [formControl]="password" (paste)="false"
                    aria-describedby="basic-addon1">
                <div *ngIf="tutor.password?.length > 0 && tutor.password != confirmacionPassword"
                    class="alert alert-danger">
                    <div>
                        La contraseña no coincide. Por favor revísala.
                    </div>
                </div>
            </div>
        </div>

        <!-- Cómo nos conociste -->
        <div class='text-lightblue'>
            <h4 class="vag-bold-font">Cómo nos conociste</h4>
        </div>

        <div class="d-block d-md-flex my-4">
            <div class="col mb-3">
                <label class="text-truncate fs-5"><input (click)="tutor.medioContacto = 'Escuela' ;
                     originTutor = '/origin/QwtMlg0lXYjUVHco9idX'" class="radio_check" name="label1" type="radio"
                        checked /> Escuela</label>
            </div>
            <div class="col mb-3">
                <label class="text-truncate fs-5"><input (click)="tutor.medioContacto = 'Folleto';
                    originTutor = '/origin/J6WySmDevp6APjtuAs7D'" class="radio_check" name="label1" type="radio" />
                    Folleto</label>
            </div>
            <div class="col mb-3">
                <label class="text-truncate fs-5"><input (click)="tutor.medioContacto = 'Redes Sociales';
                     originTutor = '/origin/bDr9WDd7OYIAuIVuT9J4'" class="radio_check" name="label1" type="radio" />
                    Redes Sociales</label>
            </div>
            <div class="col mb-3">
                <label class="text-truncate fs-5"><input (click)="tutor.medioContacto = 'Recomendación';
                    originTutor = '/origin/y6TzkBpfzF13yYrSAVx6'" class="radio_check" name="label1" type="radio" />
                    Recomendación</label>
            </div>
            <div class="col mb-3">
                <label class="text-truncate fs-5"><input (click)="tutor.medioContacto = 'Web';
                    originTutor = '/origin/43CoZKKcTzrcBgHIADJz'" class="radio_check" name="label1" type="radio" />
                    Web</label>
            </div>
        </div>

        <div class="form-check">
            <input [(ngModel)]="banderaTerminosCondiciones" class="form-check-input" type="checkbox" value=""
                id="flexCheckDefault">
            <div class="ml-3">
                <a href="https://playbots.es/politica-de-privacidad" target="_blank" class="text-secondary">
                    <u>Acepto las condiciones de uso del servicio y la política de privacidad</u></a>
            </div>
        </div>
        <div class="form-check mb-3">
            <input [(ngModel)]="banderaTerminosCondicionesContrato" class="form-check-input" type="checkbox" value=""
                id="flexCheckDefault">
            <div class="ml-3">
                <a href="https://playbots.es/terminos-y-condiciones/" target="_blank" class="text-secondary">
                <u>Acepto los Términos y Condiciones del contrato de prestación de servicios</u></a>
            </div>
        </div>
        <div class="d-flex justify-content-end px-3 pt-1 pb-2">
            <button (click)="crearUserTutor()" type="button" [disabled]="(email.invalid) || banderaDatosAlumnos || campoText1.invalid
            || campoText2.invalid || campoText3.invalid || campoNumeroDocumento.invalid || campoText5.invalid || campoText6.invalid 
            || campoText7.invalid || campoText8.invalid || emailIguales || passwordIguales || password.invalid || errorEdadTutor
            || campoNumeroDir.invalid || !documentoValido" [ngClass]="{'opacity-1': (email.invalid) || banderaDatosAlumnos || campoText1.invalid
            || campoText2.invalid || campoText3.invalid || campoNumeroDocumento.invalid || campoText5.invalid || campoText6.invalid 
            || campoText7.invalid || campoText8.invalid || emailIguales || passwordIguales || password.invalid || errorEdadTutor
            || campoNumeroDir.invalid || !banderaTerminosCondiciones || !banderaTerminosCondicionesContrato || !documentoValido}"
                class="btn btn-primary btn-lg" data-toggle="modal" data-target="#exampleModal">Siguiente</button>
        </div>
    </div>
</div>

<app-info-academica *ngIf="banderaInfoAcademica" [idTutor]="idTutor" [isCampus]="isCampus" (atras)="atrasInfoAcademica($event)">
</app-info-academica>

<!--<div [innerHTML]="messageEmail"></div>-->
<div *ngIf="cargandoModal" class="cargando">
    <mat-spinner></mat-spinner>
</div>